import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DataSetSubType, DataSetType } from "@ramudden/models/pinned-data";
import { PinnedDataService } from "@ramudden/services";
import { DomainData, DomainDataService } from "../../services/domain-data.service";

@Pipe({
    name: "dataSetName",
})
export class DataSetNamePipe implements PipeTransform {
    constructor(
        private translateService: TranslateService,
        private domainDataService: DomainDataService,
        private pinnedDataService: PinnedDataService,
    ) {}

    transform(dataSetSubType: DataSetSubType, language: string, option: DataSetType): Promise<string> {
        return this.domainDataService
            .get(DomainData.VehicleCategory, { orderBy: null })
            .then((vehicleCategories) => {
                switch (option) {
                    case DataSetType.Speed: {
                        if (dataSetSubType !== DataSetSubType.AverageSpeed) {
                            switch (dataSetSubType) {
                                case DataSetSubType.SpeedV50:
                                    return "V50";

                                case DataSetSubType.SpeedV85:
                                    return "V85";

                                case DataSetSubType.SpeedV95:
                                    return "V95";
                            }
                            break;
                        } else {
                            return this.translateService.instant("liveTiles.measuredData.average");
                        }
                    }

                    case DataSetType.Distance: {
                        if (dataSetSubType) {
                            switch (dataSetSubType) {
                                case DataSetSubType.DistanceA05:
                                    return "A05";

                                case DataSetSubType.DistanceA15:
                                    return "A15";

                                case DataSetSubType.DistanceA50:
                                    return "A50";
                            }
                        }
                        break;
                    }

                    case DataSetType.Intensity: {
                        const vehicleCategory =
                            this.pinnedDataService.getVehicleCategoryBasedOnDataSetType(dataSetSubType);
                        if (vehicleCategory) {
                            return vehicleCategories.find((x) => x.value === vehicleCategory).label;
                        }
                        break;
                    }

                    case DataSetType.ParkingOccupancy: {
                        if (dataSetSubType) {
                            return this.translateService.instant(`liveTiles.measuredData.${dataSetSubType}`);
                        }
                        break;
                    }

                    case DataSetType.Occupancy: {
                        return this.translateService.instant("liveTiles.measuredData.average");
                    }
                }
            })
            .catch((error) => {
                return "";
            });
    }
}
